
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PurchaserDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('projects');

  const stats = [
    { label: '进行中项目', value: '23', icon: 'ri-file-list-line', color: 'bg-blue-500' },
    { label: '待评审', value: '8', icon: 'ri-time-line', color: 'bg-orange-500' },
    { label: '已完成', value: '156', icon: 'ri-checkbox-circle-line', color: 'bg-green-500' },
    { label: '总投资额', value: '¥8.5亿', icon: 'ri-money-cny-circle-line', color: 'bg-purple-500' }
  ];

  const projects = [
    {
      id: 1,
      name: '市政道路改造工程项目',
      code: 'ZB2024001',
      budget: '¥5,000万',
      status: '投标中',
      bidders: 12,
      deadline: '2024-02-15',
      progress: 60
    },
    {
      id: 2,
      name: '办公楼装修工程',
      code: 'ZB2024002',
      budget: '¥800万',
      status: '评审中',
      bidders: 8,
      deadline: '2024-02-10',
      progress: 80
    },
    {
      id: 3,
      name: '信息化系统建设项目',
      code: 'ZB2024003',
      budget: '¥1,200万',
      status: '已开标',
      bidders: 15,
      deadline: '2024-02-08',
      progress: 90
    },
    {
      id: 4,
      name: '园林绿化工程',
      code: 'ZB2024004',
      budget: '¥600万',
      status: '投标中',
      bidders: 6,
      deadline: '2024-02-20',
      progress: 40
    }
  ];

  const recentActivities = [
    { id: 1, action: '项目ZB2024001收到新投标', time: '10分钟前', icon: 'ri-file-add-line', color: 'text-blue-600' },
    { id: 2, action: '项目ZB2024002评审完成', time: '1小时前', icon: 'ri-checkbox-circle-line', color: 'text-green-600' },
    { id: 3, action: '项目ZB2024003开标成功', time: '2小时前', icon: 'ri-auction-line', color: 'text-purple-600' },
    { id: 4, action: '新建项目ZB2024005', time: '3小时前', icon: 'ri-add-circle-line', color: 'text-orange-600' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                  <i className="ri-building-line text-xl text-white"></i>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">采购方工作台</h1>
                  <p className="text-sm text-gray-500">建设集团有限公司</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button className="px-4 py-2 text-gray-600 hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 whitespace-nowrap cursor-pointer">
                <i className="ri-add-line mr-2"></i>
                发布新项目
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-sm">
              <div className="border-b border-gray-200 px-6">
                <div className="flex space-x-8">
                  {[
                    { id: 'projects', label: '我的项目', icon: 'ri-folder-line' },
                    { id: 'bidders', label: '投标管理', icon: 'ri-file-list-2-line' },
                    { id: 'contracts', label: '合同管理', icon: 'ri-file-text-line' }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors ${
                        activeTab === tab.id
                          ? 'border-blue-600 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      <i className={`${tab.icon} mr-2`}></i>
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-6">
                {activeTab === 'projects' && (
                  <div className="space-y-4">
                    {projects.map((project) => (
                      <div key={project.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{project.name}</h3>
                              <span className={`px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                project.status === '投标中' ? 'bg-blue-100 text-blue-700' :
                                project.status === '评审中' ? 'bg-orange-100 text-orange-700' :
                                'bg-green-100 text-green-700'
                              }`}>
                                {project.status}
                              </span>
                            </div>
                            <div className="flex items-center space-x-6 text-sm text-gray-600">
                              <span><i className="ri-price-tag-3-line mr-1"></i>项目编号: {project.code}</span>
                              <span><i className="ri-money-cny-circle-line mr-1"></i>预算: {project.budget}</span>
                              <span><i className="ri-user-line mr-1"></i>投标企业: {project.bidders}家</span>
                            </div>
                          </div>
                        </div>
                        <div className="mb-4">
                          <div className="flex items-center justify-between text-sm mb-2">
                            <span className="text-gray-600">项目进度</span>
                            <span className="font-semibold text-gray-900">{project.progress}%</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-blue-600 h-2 rounded-full transition-all" style={{ width: `${project.progress}%` }}></div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="text-sm text-gray-600">
                            <i className="ri-calendar-line mr-1"></i>
                            截止时间: {project.deadline}
                          </div>
                          <div className="flex items-center space-x-2">
                            <button className="px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 whitespace-nowrap cursor-pointer">
                              查看详情
                            </button>
                            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 whitespace-nowrap cursor-pointer">
                              管理项目
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'bidders' && (
                  <div>
                    <div className="text-center py-12">
                      <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-file-list-2-line text-4xl text-gray-400"></i>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">投标管理</h3>
                      <p className="text-gray-600">查看和管理所有投标文件</p>
                    </div>
                  </div>
                )}

                {activeTab === 'contracts' && (
                  <div>
                    <div className="text-center py-12">
                      <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-file-text-line text-4xl text-gray-400"></i>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">合同管理</h3>
                      <p className="text-gray-600">管理所有项目合同</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Recent Activities */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">最近动态</h3>
              <div className="space-y-4">
                {recentActivities.map((activity) => (
                  <div key={activity.id} className="flex items-start space-x-3">
                    <div className={`w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0`}>
                      <i className={`${activity.icon} ${activity.color}`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-gray-900 font-medium">{activity.action}</p>
                      <p className="text-xs text-gray-500">{activity.time}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-sm p-6 text-white">
              <h3 className="text-lg font-bold mb-4">快捷操作</h3>
              <div className="space-y-3">
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-add-circle-line mr-2"></i>
                  发布新项目
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-file-search-line mr-2"></i>
                  查看投标文件
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-user-star-line mr-2"></i>
                  邀请评审专家
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
